export const constants = {
  temperature: {
    normalTemperature: 36,
    higherTemperature: 65.5,
  },
  humidity: {
    normalHumidity: 45,
    lowerHumidity: 30,
    dangerHumidity: 20,
  },
  pressure: {
    lowPressure: 1100,
    highPressure: 1200,
  },
  gas: {
    normalGas: 500,
    higherGas: 700,
  },
};
